import { render, staticRenderFns } from "./FakeItem.vue?vue&type=template&id=f7c74f1e&scoped=true&"
import script from "./FakeItem.vue?vue&type=script&lang=js&"
export * from "./FakeItem.vue?vue&type=script&lang=js&"
import style0 from "./FakeItem.vue?vue&type=style&index=0&id=f7c74f1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c74f1e",
  null
  
)

export default component.exports
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSkeleton});
